module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAcUlEQVR42u3aMQHAMADDsKAYf0KFUCC7UiDRYQK6nbZZLgAAAAAAAAAAAAAAjAMkp0sBAAAAAAAAAAAAAAAAAAAAAAAAALAO8N+vSwEAAAAAAAAAAAAAAAAAAAAAAAAAsA7gFAUAAAAAAAAAAAAAYKoHyOHoWIZhLHEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Ukraine.png
// module id = TEOy
// module chunks = 0 62 63